import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the Workbox service worker generated by `vite-plugin-pwa` (see `vite.config.ts`):
 * it precaches the app shell only; `/api/*` and `/config.json` are always network-only, so a
 * cached page never shows stale ticket data or a stale runtime config. New versions activate on
 * the next load (`autoUpdate`). Kept out of `main.tsx`'s test surface: the virtual module only
 * exists under Vite.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  registerSW({
    immediate: true,
    onRegisterError(error) {
      console.warn('Service worker registration failed', error);
    },
  });
}
